// extracted by mini-css-extract-plugin
export default {"mCard":"KE-z","image":"LE-z","imageNoBackground":"ME-z","imageHasCategory":"NE-z","fullWidth":"OE-z"};